import { render, staticRenderFns } from "./Configuration.vue?vue&type=template&id=f968c29a&scoped=true&"
import script from "./Configuration.vue?vue&type=script&lang=js&"
export * from "./Configuration.vue?vue&type=script&lang=js&"
import style0 from "./Configuration.vue?vue&type=style&index=0&id=f968c29a&lang=scss&scoped=true&"
import style1 from "./Configuration.vue?vue&type=style&index=1&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f968c29a",
  null
  
)

export default component.exports